import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';

interface ShareButtonProps {
  title: string;
  description: string;
  imageUrl: string;
  url?: string;
}

const ShareButton: React.FC<ShareButtonProps> = ({ 
  title, 
  description, 
  imageUrl,
  url 
}) => {
  // Update meta tags when component mounts
  useEffect(() => {
    // Get the current URL or use the provided one
    const shareUrl = url || window.location.href;
    
    // Update Open Graph meta tags
    const ogTitle = document.getElementById('og-title');
    const ogDescription = document.getElementById('og-description');
    const ogImage = document.getElementById('og-image');
    const ogUrl = document.getElementById('og-url');
    
    // Update Twitter meta tags
    const twitterTitle = document.getElementById('twitter-title');
    const twitterDescription = document.getElementById('twitter-description');
    const twitterImage = document.getElementById('twitter-image');
    const twitterUrl = document.getElementById('twitter-url');
    
    if (ogTitle) ogTitle.setAttribute('content', title);
    if (ogDescription) ogDescription.setAttribute('content', description);
    if (ogImage) ogImage.setAttribute('content', imageUrl);
    if (ogUrl) ogUrl.setAttribute('content', shareUrl);
    
    if (twitterTitle) twitterTitle.setAttribute('content', title);
    if (twitterDescription) twitterDescription.setAttribute('content', description);
    if (twitterImage) twitterImage.setAttribute('content', imageUrl);
    if (twitterUrl) twitterUrl.setAttribute('content', shareUrl);
    
    // Cleanup function to reset meta tags
    return () => {
      if (ogTitle) ogTitle.setAttribute('content', 'Natakiya');
      if (ogDescription) ogDescription.setAttribute('content', 'Natakiya - For theater lovers');
      if (ogImage) ogImage.setAttribute('content', '%PUBLIC_URL%/logo.png');
      if (ogUrl) ogUrl.setAttribute('content', '');
      
      if (twitterTitle) twitterTitle.setAttribute('content', 'Natakiya');
      if (twitterDescription) twitterDescription.setAttribute('content', 'Natakiya - For theater lovers');
      if (twitterImage) twitterImage.setAttribute('content', '%PUBLIC_URL%/logo.png');
      if (twitterUrl) twitterUrl.setAttribute('content', '');
    };
  }, [title, description, imageUrl, url]);

  const handleShare = async () => {
    const shareUrl = url || window.location.href;
    
    // Use Web Share API if available
    if (navigator.share) {
      try {
        await navigator.share({
          title: title,
          text: description,
          url: shareUrl,
        });
      } catch (error) {
        console.error('Error sharing:', error);
        fallbackShare(shareUrl);
      }
    } else {
      fallbackShare(shareUrl);
    }
  };

  // Fallback for browsers that don't support Web Share API
  const fallbackShare = (shareUrl: string) => {
    // Create a temporary input to copy the URL
    const tempInput = document.createElement('input');
    document.body.appendChild(tempInput);
    tempInput.value = shareUrl;
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
    
    alert('Link copied to clipboard! You can now paste it in your social media.');
  };

  return (
    <Button 
      onClick={handleShare}
      className="share-button"
      style={{
        backgroundColor: '#FFD600',
        color: '#810081',
        border: 'none',
        borderRadius: '10px',
        padding: '8px 16px',
      }}
    >
      <i className="bi bi-share me-2"></i>
      Share
    </Button>
  );
};

export default ShareButton;